import io from "socket.io-client";
import { IP } from "../config/IP";

console.log("IP config=", IP);
const ENDPOINT = IP.nodeServer;
const token = localStorage.getItem("token");
const socket = io.connect(ENDPOINT, {
	query: { token: token },
});

export default socket;
